import { Subject } from 'rxjs';

const viewAllMetricsSubject = new Subject();

export const updateViewAllMetricsSubject = {
  update: message => viewAllMetricsSubject.next(message),
  clear: () => viewAllMetricsSubject.next(),
  get: () => viewAllMetricsSubject.asObservable()
};
